import DownloadImportTemplateService from '@/services/admin/DownloadImportTemplateService.js'

export const namespaced = true

export const actions = {
  download({ commit }, type) {
    return new Promise(resolve => {
      DownloadImportTemplateService.download(type).then(response => {
        resolve(response)
      })
    })
  }
}
